import OrbitApiV1 from '.'

class UserAPI {
  static getPfpByUserId(userId, header = {}) {
    // if(email === 'demo@circles.asia') --> get from indexedDB
    return OrbitApiV1.httpGet(`/upload?userId=${userId}`, header)
  }

  static uploadPfp(userId, pic, header = {}) {
    return OrbitApiV1.httpPost(`/upload?userId=${userId}`, header, pic)
  }

  static getUserByEmail(email) {
    return OrbitApiV1.httpGet(`/user/email/${email}`)
  }

  static getUserById(id) {
    return OrbitApiV1.httpGet(`/user/id/${id}`)
  }

  static updateFirstLogin(user, header = {}) {
    return OrbitApiV1.httpPut(`/user/update/firstLogin/${user._id}`, header, {
      firstLogin: false
    })
  }

  static createUser(user, header = {}) {
    return OrbitApiV1.httpPut(`/user/create`, header, user)
  }

  static updateUser(user, header = {}) {
    return OrbitApiV1.httpPut(`/user/update`, header, user)
  }

  static deleteUser(user) {
    return OrbitApiV1.httpDelete(`/user/delete/${user}`)
  }

  static getUserByQuery(queries) {
    let queryString = `/user`

    if (Object.keys(queries).length > 0) {
      queryString += '?'

      for (const [key, value] of Object.entries(queries)) {
        queryString += `${key}=${value}&`
      }
    }

    queryString += 'details=1'

    return OrbitApiV1.httpGet(queryString)
  }
}

export default UserAPI
